import { LinkTo } from '@ember/routing';
import Component from '@glimmer/component';
import { VStack } from 'tio-reimagined/components/layout';
import {
  PhChartBar,
  PhUsers,
  PhBrain,
  PhUsersFour,
  PhTrendUp,
  PhArrowLeft,
} from 'ember-phosphor-icons';

export default class CareerPathwaysAdminRoute extends Component {
  <template>
    {{! template-lint-disable no-bare-strings }}
    <VStack class="w-full min-w-0">
      {{! Admin Navigation }}
      <div class="app-page-subheader -mx-4 -mt-4 px-4 mb-6">
        <div class="flex items-center justify-between py-3">
          <LinkTo
            @route="authenticated.reimagined"
            class="flex items-center gap-2 text-[var(--text-tertiary)] hover:text-[var(--text-secondary)]"
          >
            <PhArrowLeft @size={{18}} />
            <span class="text-sm">Back to Employee View</span>
          </LinkTo>
        </div>
        <nav class="app-page-subnav">
          <LinkTo
            @route="authenticated.reimagined.admin.index"
            class="app-page-subnav-link"
            @activeClass="app-page-subnav-link--active"
          >
            <PhChartBar @size={{18}} />
            Overview
          </LinkTo>
          <LinkTo
            @route="authenticated.reimagined.admin.team"
            class="app-page-subnav-link"
            @activeClass="app-page-subnav-link--active"
          >
            <PhUsers @size={{18}} />
            Team View
          </LinkTo>
          <LinkTo
            @route="authenticated.reimagined.admin.skills-inventory"
            class="app-page-subnav-link"
            @activeClass="app-page-subnav-link--active"
          >
            <PhBrain @size={{18}} />
            Skills Inventory
          </LinkTo>
          <LinkTo
            @route="authenticated.reimagined.admin.leadership"
            class="app-page-subnav-link"
            @activeClass="app-page-subnav-link--active"
          >
            <PhUsersFour @size={{18}} />
            Leadership
          </LinkTo>
          <LinkTo
            @route="authenticated.reimagined.admin.program-effectiveness"
            class="app-page-subnav-link"
            @activeClass="app-page-subnav-link--active"
          >
            <PhTrendUp @size={{18}} />
            Program ROI
          </LinkTo>
        </nav>
      </div>

      {{outlet}}
    </VStack>
  </template>
}
